import { render, staticRenderFns } from "./SavingsEditor.vue?vue&type=template&id=bf77c116&"
import script from "./SavingsEditor.vue?vue&type=script&lang=js&"
export * from "./SavingsEditor.vue?vue&type=script&lang=js&"
import style0 from "./SavingsEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports